import { Link } from 'react-router-dom';
import {
  Badge,
  Button,
  Card,
  CardHeader,
  EmptyState,
  ErrorState,
  LoadingState,
} from '../components';
import { formatDateTime } from '../features/results/ResultCard';
import { JobStatusBadge } from '../features/search/JobStatusBadge';
import { useSearchList } from '../hooks/use-searches';
import { describeError } from '../services/errors';

export function HistoryPage() {
  const searches = useSearchList(20);
  const items = searches.data?.pages.flatMap((page) => page.data) ?? [];

  return (
    <Card>
      <CardHeader
        title="Histórico de pesquisas"
        description="Todas as suas consultas, da mais recente para a mais antiga."
        action={
          <Link to="/pesquisas/nova">
            <Button size="sm">Nova pesquisa</Button>
          </Link>
        }
      />

      {searches.isPending && <LoadingState label="Carregando histórico" />}

      {searches.isError && (
        <ErrorState
          message={describeError(searches.error)}
          onRetry={() => void searches.refetch()}
        />
      )}

      {!searches.isPending && !searches.isError && items.length === 0 && (
        <EmptyState
          title="Nenhuma pesquisa no histórico"
          description="Pesquisas executadas aparecem aqui e podem ser reabertas a qualquer momento."
        />
      )}

      {items.length > 0 && (
        <>
          <ul className="flex flex-col divide-y divide-border">
            {items.map((search) => (
              <li key={search.id} className="py-3">
                <Link to={`/pesquisas/${search.id}`} className="flex flex-col gap-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-sm font-medium text-text">
                      {search.label ?? search.terms.join(', ') ?? 'Pesquisa'}
                    </span>
                    <JobStatusBadge status={search.status} />
                    {search.platforms.map((platform) => (
                      <Badge key={platform}>{platform}</Badge>
                    ))}
                  </div>
                  <span className="text-xs text-text-muted">
                    {formatDateTime(search.dateFrom)} até {formatDateTime(search.dateTo)} ·{' '}
                    {search.resultCount} resultado(s) · criada em {formatDateTime(search.createdAt)}
                  </span>
                </Link>
              </li>
            ))}
          </ul>

          {searches.hasNextPage && (
            <div className="mt-4 flex justify-center">
              <Button
                variant="secondary"
                loading={searches.isFetchingNextPage}
                onClick={() => void searches.fetchNextPage()}
              >
                Carregar mais
              </Button>
            </div>
          )}
        </>
      )}
    </Card>
  );
}
